import * as React from 'react';
import { useFormContext } from '@cian/frontend-request-form-widget';
import { BottomBanner } from '../../../components/OfferComplain';
import { jsx as _jsx } from "react/jsx-runtime";
export var OfferComplaintBottomBannerContainer = function OfferComplaintBottomBannerContainer() {
  var _useFormContext = useFormContext(),
    submitForm = _useFormContext.submitForm;
  var handleLkLinkClick = function handleLkLinkClick() {
    submitForm();
  };
  return /*#__PURE__*/_jsx(BottomBanner, {
    onClick: handleLkLinkClick
  });
};